import { useSelector } from "react-redux";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { selectRoutePointsListItems } from "../../../../../../redux/route-management/route-points/selector";
import { routePoints } from "../../../../../../redux/route-management/route-points/action";


const TransporterRoutePoints = () => {
	const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
    const orderItems = useSelector(selectRoutePointsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'LocationName', headerName: 'Location Name', sortable: true, filter: true,isEdit: true  },
          { field: 'RouteNumber', headerName: 'Route Number' },
          { field: 'Remarks', headerName: 'Remarks' }
      
        ]);
      }
      const fetchRoutePoints=()=>{
        dispatch(routePoints.list({url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/route-management/route-points/list`,entity:'routePoints',jsonData:{
        
        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc", 
        // "Filters": [
          //     {
          //       "FieldName": "CustomerId",
          //       "FilterOperatorId": 1,
          //       "FieldValue": 316999,
          //       "FieldType": "number"
          //     }
          //   ],
      }}))
      }  
	useEffect(() => {
        createColumnDefs()
        fetchRoutePoints()
	}, [pageData])

	return (
    
		<Table columnData={columnDefs} rowData={orderItems?.result?.items} setPageData={setPageData}
    paginationData={orderItems?.result?.pagination}headingName="Route Points" />
      
     
	);
};

export default TransporterRoutePoints;


